import React, { useState } from 'react'
import { TaskCard } from '../../types/task-board'

interface TaskCardCommentsProps {
  card: TaskCard
  onAddComment: (cardId: string, commentContent: string) => Promise<void>
}

export const TaskCardComments: React.FC<TaskCardCommentsProps> = ({ card, onAddComment }) => {
  const [commentContent, setCommentContent] = useState('')

  const handleAddCommentClick = () => {
    if (commentContent.trim()) {
      onAddComment(card.id, commentContent)
      setCommentContent('')
    }
  }

  return (
    <div style={{
      border: '1px solid #e9ecef',
      borderRadius: '5px',
      padding: window.innerWidth < 768 ? '10px' : '15px',
      backgroundColor: '#fff'
    }}
    >
      <h4 style={{ fontSize: window.innerWidth < 768 ? '15px' : '16px', fontWeight: 600, marginBottom: window.innerWidth < 768 ? '10px' : '15px' }}>
        Komentarze
      </h4>

      {card.comments.length > 0
        ? (
          <div style={{ marginBottom: '20px' }}>
            {card.comments.map(comment => (
              <div key={comment.id} style={{ marginBottom: '12px', padding: window.innerWidth < 768 ? '8px' : '10px', backgroundColor: '#f8f9fa', borderRadius: '5px', borderLeft: '3px solid #dee2e6' }}>
                <div style={{ display: 'flex', alignItems: window.innerWidth < 768 ? 'center' : 'flex-start', flexDirection: window.innerWidth < 768 ? 'column' : 'row' }}>
                  <div style={{ display: 'flex', alignItems: 'center', width: window.innerWidth < 768 ? '100%' : 'auto', marginBottom: window.innerWidth < 768 ? '8px' : '0' }}>
                    {comment.author.avatar && (
                      <div style={{ width: window.innerWidth < 768 ? '28px' : '36px', height: window.innerWidth < 768 ? '28px' : '36px', borderRadius: '50%', marginRight: '8px', backgroundColor: '#007bff', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: window.innerWidth < 768 ? '14px' : '16px', fontWeight: 'bold', flexShrink: 0 }}>
                        {comment.author.username.charAt(0).toUpperCase()}
                      </div>
                    )}
                    <div style={{ display: 'flex', flexDirection: window.innerWidth < 768 ? 'row' : 'column', justifyContent: window.innerWidth < 768 ? 'space-between' : 'flex-start', width: window.innerWidth < 768 ? '100%' : 'auto', alignItems: window.innerWidth < 768 ? 'center' : 'flex-start' }}>
                      <strong style={{ fontSize: window.innerWidth < 768 ? '13px' : '14px', marginRight: window.innerWidth < 768 ? '8px' : '0' }}>
                        {comment.author.username}
                      </strong>
                      <span style={{ fontSize: '11px', color: '#6c757d' }}>
                        {new Date(comment.createdAt).toLocaleString(undefined, { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' })}
                      </span>
                    </div>
                  </div>
                  <div style={{ width: '100%', borderTop: window.innerWidth < 768 ? '1px solid #eee' : 'none', paddingTop: window.innerWidth < 768 ? '8px' : '0' }}>
                    <p style={{ margin: 0, fontSize: window.innerWidth < 768 ? '13px' : '14px', lineHeight: '1.4', wordBreak: 'break-word' }}>
                      {comment.content}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
          )
        : (
          <p style={{ fontSize: window.innerWidth < 768 ? '13px' : '14px', fontStyle: 'italic', color: '#6c757d', margin: '10px 0' }}>
            Brak komentarzy
          </p>
          )}

      <div style={{ marginTop: '15px' }}>
        <h5 style={{ fontSize: window.innerWidth < 768 ? '14px' : '15px', fontWeight: 600, marginBottom: '8px' }}>
          Dodaj komentarz
        </h5>
        <textarea
          value={commentContent}
          onChange={(e) => setCommentContent(e.target.value)}
          style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ced4da', fontSize: window.innerWidth < 768 ? '13px' : '14px', minHeight: window.innerWidth < 768 ? '60px' : '80px', marginBottom: '8px', resize: 'vertical', boxSizing: 'border-box' }}
          placeholder='Wpisz swój komentarz...'
        />
        <button
          onClick={handleAddCommentClick}
          disabled={!commentContent.trim()}
          style={{ backgroundColor: '#007bff', color: 'white', border: 'none', padding: '6px 10px', borderRadius: '4px', cursor: commentContent.trim() ? 'pointer' : 'not-allowed' }}
        >
          Dodaj komentarz
        </button>
      </div>
    </div>
  )
}
